export default __webpack_public_path__ + "static/media/pharrell.5780e818.png";